import React, { Component, Fragment } from 'react';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { DetailsList, ConstrainMode, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { MessageBars } from '../Outils/MessageBars';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import Scriba from 'react-scriba';
import { DataNews } from '../../data/DataNews';
import { FromDateToDatePicker } from '../Outils/FromDateToDatePicker';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

export class DetailsListNewsLecture extends Component {

    constructor(props) {
        super(props);

        const columns = [
            {
                isSorted: true,
                isSortedDescending: false,
                isResizable: true,
                key: 'creerLe',
                minWidth: 100,
                maxWidth: 100,
                name: 'Créée le',
                onRender: (item) => {
                    return <span>{Scriba.date().stringDateFormatCourt(item.creerLe)}</span>;
                }
            },
            {
                isResizable: true,
                key: 'titre',
                minWidth: 150,
                maxWidth: 200,
                name: 'Titre',
                onRender: (item) => {
                    let titre = item.titre;
                    return <span title={titre}>{titre}</span>;
                }
            },
            {
                isResizable: true,
                key: 'contenu',
                minWidth: 150,
                name: 'Message',
                onRender: (item) => {
                    let contenu = item.contenu;
                    return <span title={contenu}>{contenu}</span>;
                }
            },
            {
                iconName: null,
                isIconOnly: true,
                key: 'afficher',
                minWidth: 25,
                maxWidth: 25,
                name: 'afficher',
                onRender: (item) => {
                    return <IconButton
                        iconProps={{ iconName: 'Zoom' }}
                        onClick={() => this._onClickOpenFicheNews(item)}
                        title="Afficher la news"
                    />;
                }
            }
        ];

        this.state = {
            items: [],
            activeNews: {},
            isOpenFicheNews: false,
            filterBy: {
                fromDate: null,
                toDate: null,
                keyword: '',
                idTypeMandat: true
            },
            sortedColumn: "creerLe",
            isSortedDescending: true,
            columns: columns,
            enCoursDeTraitement: false,
            messageEnCoursTraitement: '',
            isOpenPanelFiltres: false,
            hideMessageBarFiltres: true,
            hideMessageBarWarning: true,
            hideMessageBarError: true,
            warningMessage: '',
            errorMessage: '',
            messageMessageBarFiltres: ''
        };
    }

    _creationContent = () => {
        return <DetailsList
            columns={this.state.columns}
            constrainMode={ConstrainMode.unconstrained}
            items={this.state.items}
            onColumnHeaderClick={this._onClickColumnHeader}
            onRenderDetailsHeader={this._onRenderDetailsHeader}
            selectionMode={SelectionMode.none}
        />
    }

    _chargementDonnees = () => {
        if (!this.state.enCoursDeTraitement) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement des news en cours'
            });

            this.state.filterBy.idTypeMandat = true; //On affiche uniquement les news du mandat de la personne connectée
            let chargementNews = DataNews._onChargementNews(this.state.filterBy, this.include, this.state.sortedColumn, this.state.isSortedDescending);

            chargementNews
                .then(responseFetch => {
                    const retourVerif = Scriba.fetch().traitementRetour(responseFetch, this, 100);
                    let newState = {
                        enCoursDeTraitement: false,
                        messageEnCoursTraitement: '',
                        hideMessageBarWarning: retourVerif.hideMessageBarWarning,
                        warningMessage: retourVerif.warningMessage,
                        hideMessageBarError: retourVerif.hideMessageBarError,
                        errorMessage: retourVerif.errorMessage
                    };
                    if (retourVerif.hideMessageBarWarning && retourVerif.hideMessageBarError) {
                        //YD : 17/06/2020 : Ajout test sur listeItem != null
                        let listeItem = (responseFetch.reponseAPIobjet !== null ? responseFetch.reponseAPIobjet : []);
                        newState.items = listeItem;
                    };
                    this.setState(newState);
                });
        }
    };

    _getFarItems = () => {
        return [
            {
                key: 'nombreEnregistrement',
                name: this.state.items ? this.state.items.length : 0
            },
            {
                key: 'filtres',
                iconOnly: true,
                iconProps: { iconName: 'Filter' },
                name: 'Filtres',
                onClick: () => this._onClickOpenPanelFiltres()
            }
        ];
    };
    _getItems = () => {
        return [
            {
                key: 'search',
                onRender: () => <SearchBox
                    className="searchBox"
                    onClear={(ev) => this._onSearch("")}
                    onSearch={(newValue) => this._onSearch(newValue)}
                    placeholder="Recherche rapide"
                />
            }
        ];
    };
    _onSearch = (text) => {
        let filter = {};
        filter.keyword = text;

        this.setState({
            filterBy: filter
        }, () => {
            this._chargementDonnees()
        });
    };

    _onClickColumnHeader = (ev, column) => {
        const key = column.key;

        const { columns } = this.state;
        const newColumns = columns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = false;
            }
        });

        let sortedColumn = key;
        let isSortedDescending = typeof column.isSortedDescending !== 'undefined' && column.isSortedDescending;

        this.setState({
            sortedColumn: sortedColumn,
            isSortedDescending: isSortedDescending
        }, () => {
            this._chargementDonnees()
        });
    };
    _onRenderDetailsHeader = (props, defaultRender) => {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
            {defaultRender({
                ...props,
                onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
            })}
        </Sticky>
    };

    _onClickOpenFicheNews = (activeNews) => {
        activeNews = activeNews || { idNews: 0, titre: "", contenu: "" }
        this.setState({
            activeNews: activeNews,
            isOpenFicheNews: true
        });
    }
    _onRenderFicheNewsFooterContent = () => {
        return (
            <Fragment>
                <DefaultButton onClick={this._onDismissFicheNews}>Fermer</DefaultButton>
            </Fragment>
        );
    }
    _onDismissFicheNews = () => {
        this.setState({
            isOpenFicheNews: false,
            activeNews: {}
        });
    };

    _onClickOpenPanelFiltres = () => {
        this.setState({
            isOpenPanelFiltres: true
        });
    };
    _onSelectFiltreDate = (fromDate, toDate) => {
        let filter = {};
        filter.fromDate = fromDate;
        filter.toDate = toDate;

        this.setState({
            filterBy: filter
        });
    };
    _onClickResetFilters = () => {
        let filter = {};
        filter.fromDate = null;
        filter.toDate = null;

        this.setState({
            filterBy: filter
        });
    }
    _onRenderFiltresFooterContent = () => {
        return (
            <Fragment>
                <PrimaryButton onClick={this._onApplyFilters} className="marginRight8px">Valider</PrimaryButton>
                <DefaultButton onClick={this._onDismissPanelFiltres}>Fermer</DefaultButton>
            </Fragment>
        );
    }
    _onDismissPanelFiltres = () => {
        this.setState({
            isOpenPanelFiltres: false
        });
    };
    _onApplyFilters = () => {
        this.setState({
            isOpenPanelFiltres: false
        });
        this._chargementDonnees();
    };

    componentDidMount() {
        this._chargementDonnees();
    };

    render = () => {

        const content = this._creationContent();

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    ariaLabel={"Utiliser les flèches droite et gauche pour naviguer"}
                    farItems={this._getFarItems()}
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                />

                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}                        >
                        {content}
                    </ScrollablePane>
                </div>
            </Stack>

            <Panel
                closeButtonAriaLabel="Fermer"
                headerText="Filtres"
                isOpen={this.state.isOpenPanelFiltres}
                onDismiss={this._onDismissPanelFiltres}
                onRenderFooterContent={this._onRenderFiltresFooterContent}
                type={PanelType.smallFixedFar}
            >
                <div className="d-flex flex-column">
                    <div className="d-flex flex-row-reverse">
                        <IconButton
                            iconProps={{ iconName: 'ClearFilter' }}
                            className="buttonFiltres"
                            title="Réinitialiser les filtres"
                            ariaLabel="Filtres"
                            onClick={this._onClickResetFilters}
                        />
                    </div>
                    <FromDateToDatePicker
                        fromDate={this.state.filterBy.fromDate}
                        toDate={this.state.filterBy.toDate}
                        onSelectDate={(fromDate, toDate) => this._onSelectFiltreDate(fromDate, toDate)}
                    />
                </div>
            </Panel>

            <Panel
                closeButtonAriaLabel="Fermer"
                headerText={this.state.activeNews.titre}
                isOpen={this.state.isOpenFicheNews}
                onDismiss={this._onDismissFicheNews}
                onRenderFooterContent={this._onRenderFicheNewsFooterContent}
                type={PanelType.large}
            >
                <Label>{this.state.activeNews.contenu}</Label>
            </Panel>

        </Fragment>;
    };
}